import Image from 'next/image';
import Link from 'next/link';
import type { BlogPostProps } from '@/types/blog';

export default function BlogCard({
  title,
  excerpt,
  date,
  author,
  category,
  slug,
  imageSrc
}: BlogPostProps) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 shadow-sm backdrop-blur overflow-hidden transition-all hover:-translate-y-1 hover:border-accent/25 hover:bg-white/10">
      <Link href={`/blog/${slug}`} className="block">
        <div className="relative h-48 w-full">
          <Image
            src={imageSrc || '/images/blog/default.webp'}
            alt={title}
            fill
            className="object-cover"
            sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
            loading="lazy"
          />
        </div>
      </Link>
      
      <div className="p-6">
        <div className="flex items-center mb-3">
          <span className="inline-block rounded-full border border-white/10 bg-white/5 text-white/80 text-xs px-2 py-1">
            {category}
          </span>
          <span className="text-white/60 text-sm ml-3">{date}</span>
        </div>
        
        <Link href={`/blog/${slug}`} className="block">
          <h3 className="text-xl font-semibold text-white mb-2 hover:text-accent transition-colors">
            {title}
          </h3>
        </Link>
        
        <p className="text-white/70 text-sm mb-4 line-clamp-3">
          {excerpt}
        </p>
        
        <div className="flex items-center pt-3 border-t border-white/10">
          <div className="flex-shrink-0">
            <div className="h-8 w-8 rounded-full overflow-hidden">
              <Image 
                src={author.image || '/images/team/default.webp'} 
                alt={author.name}
                width={32}
                height={32}
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium text-white/80">{author.name}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
